/**
 * OD-35 (founder decision, 2026-10-15) provenance vocabulary for one CORE-J work-ledger entry.
 *
 *   observed -> "Recorded Measurement": the work and its minutes were captured directly by OptiBay's work timer.
 *   imported -> "Reported by External Source (imported history)": history a shop imported from its previous system
 *               (creation_method csv_import); OptiBay did not capture it and has not independently verified it.
 *
 * Shared by the Passport ledger and the Connect projection so the two surfaces never drift (CORE-J Prov).
 */
export const WORK_LEDGER_OBSERVED_LABEL = 'Recorded Measurement';
export const WORK_LEDGER_IMPORTED_LABEL = 'Reported by External Source (imported history)';

export function workLedgerSourceLabel(sourceKind: string | null | undefined): string {
  return sourceKind === 'imported' ? WORK_LEDGER_IMPORTED_LABEL : WORK_LEDGER_OBSERVED_LABEL;
}
